import React from 'react';
import { Box, Typography, Tooltip, Fab } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useSearchParams } from 'react-router-dom';

import ExportConfig from '../../../../components/buttons/ExportConfig';
import DateRangePicker from '../../../../components/filters/DateRangePicker';
import ChipFilter from '../../../../components/filters/ChipFilter';
import styles from './MeterFilters.styles';
import { getMeterTypeName, toggleFilterAndSync, clearFilterAndSync } from '../../utils/meter.helpers';

export default function MeterFilters({
  filters,
  setFilters,
  dateRange,
  setDateRange,
  meterNumberOptions = [],
  unitOptions = [],
  evnOptions = [],
  meterTypeOptions = [],
  onAdd,
}) {
  const [searchParams, setSearchParams] = useSearchParams();

  const onToggle = (type, value) => {
    setFilters((prev) => toggleFilterAndSync(type, value, prev, searchParams, setSearchParams));
  };

  const onClear = (type) => {
    setFilters((prev) => clearFilterAndSync(type, prev, searchParams, setSearchParams));
  };

  return (
    <Box sx={styles.filterRow}>
      <Box sx={styles.filterLeft}>
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 600 }}>Filters:</Typography>

        <ChipFilter
          label="Meter Number"
          type="meterNumber"
          values={meterNumberOptions}
          selectedValues={filters.meterNumber}
          onToggle={onToggle}
          onClear={onClear}
        />

        <ChipFilter
          label="Unit"
          type="unit"
          values={unitOptions}
          selectedValues={filters.unit}
          onToggle={onToggle}
          onClear={onClear}
        />

        <ChipFilter
          label="EVN"
          type="evn"
          values={evnOptions}
          selectedValues={filters.evn}
          onToggle={onToggle}
          onClear={onClear}
        />

        <ChipFilter
          label="Meter Type"
          type="meterType"
          values={meterTypeOptions.map(getMeterTypeName)}
          selectedValues={filters.meterType}
          onToggle={onToggle}
          onClear={onClear}
        />

        <DateRangePicker dateRange={dateRange} setDateRange={setDateRange} />
      </Box>

      <Box sx={styles.rightControls}>
        <ExportConfig sx={styles.fabButton} />
        <Tooltip title="Add new meter">
          <Fab size="small" sx={styles.fabButton} onClick={onAdd}>
            <AddIcon fontSize="small" />
          </Fab>
        </Tooltip>
      </Box>
    </Box>
  );
}
